var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8C39.1046 8 40 8.89543 40 10V26C40 27.1046 39.1046 28 38 28H29.333C28.2286 28.0002 27.333 28.8955 27.333 30V38C27.333 39.1046 26.4376 40 25.333 40H22.667C21.5624 40 20.667 39.1046 20.667 38V30C20.667 28.8955 19.7714 28.0002 18.667 28H10C8.89543 28 8 27.1046 8 26V10C8 8.89543 8.89543 8 10 8H38ZM10 26H18.667C20.809 26.0002 22.5581 27.6845 22.6621 29.8008L22.667 30V38H25.333V30C25.333 27.8578 27.0174 26.1089 29.1338 26.0049L29.333 26H38V24H10V26ZM10 22H38V10H34V19C34 19.5523 33.5523 20 33 20C32.4477 20 32 19.5523 32 19V10H27V14C27 14.5523 26.5523 15 26 15C25.4477 15 25 14.5523 25 14V10H20V17C20 17.5523 19.5523 18 19 18C18.4477 18 18 17.5523 18 17V10H10V22Z",
    fill: "#1B1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.e1ce61def5dfb9e21294a24aafc0f85b.svg";
export { ForwardRef as ReactComponent };